module.exports = function() {
  return new Worker(__webpack_public_path__ + "8a5fbb66b340d372ed03.worker.js");
};